import { NotificationsRounded } from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  Drawer,
  IconButton,
  ModalClose,
  Typography,
} from "@mui/joy";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Messages from "./includes/Messages";
import { useNotifications } from "core/hooks/useNotifications";
import { getTokenOrDefault } from "helpers/Storage";
import { useNotificationAction } from "core/hooks/useNotificationAction";
import { useProfileContext } from "contexts/ProfileContext";
import { getEnv } from "helpers/Env";
import TAlert from "components/common/TAlert";
import { pageAlert } from "./utils";

const Notifications = () => {
  const [open, setOpen] = useState(false);
  const { profile } = useProfileContext();

  const token = getTokenOrDefault();
  const { notifications, count, getMessages, getCount } =
    useNotifications(token);
  const { clear, read } = useNotificationAction(token);

  useEffect(() => {
    const eventSource = new EventSource(
      `${getEnv("API_ENDPOINT")}/events/${profile?.account_id}`
    );
    eventSource.onmessage = async (event) => {
      if (event.data == '"NOTIFICATION"') {
        pageAlert(
          <TAlert message="You have a new message!" variant="info" />,
          "info"
        );

        await getCount();        
      }
    };

    return () => {
      eventSource.close();
    };
  }, []);

  useEffect(() => {
    if (open) {
      getMessages();
    }
    getCount();
  }, [open]);

  const handleClear = async () => {
    await clear();
    await getCount();
    await getMessages();
  };

  const handleRead = async () => {
    await read();
    await getCount();
    await getMessages();
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}>
          <Typography component="span" sx={{ fontWeight: "400" }}>
            <Link
              style={{ textDecoration: "none" }}
              to={`/dashboard?getStarted=true`}
            >
              Get Started!
            </Link>
          </Typography>
        </Typography>
        <IconButton
          onClick={() => setOpen(true)}
          variant="plain"
          color="neutral"
          size="md"
        >
          <Badge badgeContent={count} showZero={false} size="sm">
            <NotificationsRounded />
          </Badge>
        </IconButton>
      </Box>

      <Drawer
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        anchor="right"
        size="sm"
        sx={{
          zIndex: 1000,
          overflow: "hidden",
          "& .MuiDrawer-content": {
            width: {
              xs: "100vw",  
              sm: "100vw",
              md: 360,      
            },
            maxWidth: "100vw",
          },
          "& .MuiDrawer-backdrop": {
            backdropFilter: "blur(1px)",
          },
        }}
      >
        <ModalClose />
        <Box
          role="presentation"
          sx={{
            padding: (theme) => theme.spacing(3),
            height: "100%",
            overflow: "hidden",
          }}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          gap={2}
        >
          <Messages data={notifications} count={count} />

          <Button
            size="sm"
            variant="outlined"
            color="primary"
            onClick={handleRead}
            disabled={notifications.length == 0}
          >
            Mark All As Read
          </Button>

          <Button
            size="sm"
            variant="outlined"
            color="danger"
            onClick={handleClear}
            disabled={notifications.length == 0}
          >
            Clear All
          </Button>
        </Box>
      </Drawer>
    </React.Fragment>
  );
};

export default Notifications;
